import Badge from '@material-ui/core/Badge';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import { ArrowBack } from '@material-ui/icons';
import React from 'react';
import { connect } from 'react-redux';
import { Badge as VitaBadge, BodyTextMedium, HeadingText10 } from '@modernhealth/vital-components';
import { WithStyles, withStyles } from '@material-ui/core/styles';

import { store } from 'src/config/Store';

enum ChatPanelHeaderTestID {
  ClientProfileButton = 'ChatPanelHeaderTestID.ClientProfileButton',
}

const styles = () => ({
  topics: {
    paddingLeft: 8,
  },
  topicsContainer: {
    display: 'flex',
    paddingLeft: 16,
    paddingBottom: 16,
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
  },
});
interface ChatPanelHeaderProps {
  title: string;
  description?: string;
  onClickBack?: () => void;
  unreadMessagesCount: number;
  onClickChatMemberSettings?: () => void;
  testID?: string;
  showTopics?: boolean;
  topicsOfFocus?: string[];
}

type Props = WithStyles & ChatPanelHeaderProps;

const ChatPanelHeader: React.FC<Props> = ({
  classes,
  title,
  description,
  unreadMessagesCount,
  // tslint:disable-next-line:no-empty
  onClickChatMemberSettings,
  // tslint:disable-next-line:no-empty
  onClickBack = () => {},
  testID = '',
  showTopics = false,
  topicsOfFocus = [],
}) => {
  return (
    <div className="bg-white border-b border-gray-200">
      <div className="p-4 flex flex-row items-center justify-between">
        <div className="inline-flex items-center">
          {onClickBack && (
            <Hidden mdUp>
              <IconButton onClick={onClickBack} className="mr-6">
                <Badge color="secondary" variant="dot" invisible={!unreadMessagesCount}>
                  <ArrowBack />
                </Badge>
              </IconButton>
            </Hidden>
          )}
          <h4 className="font-bold text-xl m-0" data-testid={testID}>
            {title}
          </h4>
          {description ? <p className="text-base text-gray-600">{description}</p> : null}
        </div>
        {onClickChatMemberSettings && (
          <BodyTextMedium fontColor="blue55" className={classes.link}>
            <p
              onClick={onClickChatMemberSettings}
              data-testid={ChatPanelHeaderTestID.ClientProfileButton}
            >
              Client Profile
            </p>
          </BodyTextMedium>
        )}
      </div>

      {showTopics && topicsOfFocus?.length > 0 && (
        <div className={classes.topicsContainer}>
          <HeadingText10>Topic of focus: </HeadingText10>
          {topicsOfFocus.map((value) => (
            <div className={classes.topics} key={`badge-${value}`}>
              <VitaBadge title={value} size="medium" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  unreadMessagesCount: store.select.chat.unreadMessagesCount(state),
});

export default withStyles(styles)(connect(mapStateToProps)(ChatPanelHeader));
